import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLock} from '@netx/core-icons';
import {canLockAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionLockIcon = faLock;

/**
 * Lock asset
 * @param params
 * @returns Action
 */
export const assetActionLock = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-lock',
	cb: () => dispatcher.trigger(ASSET_EVENT.LOCK, asset),
	enableTest: () => canLockAsset(asset),
	icon: assetActionLockIcon,
	get label() {
		return AssetActionLabel.LOCK;
	},
	...params,
});

export default assetActionLock;
